import React, { useState, useContext } from 'react';
import axios from 'axios';
import { UserContext } from '../../UserContext';
import { Link, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import config from '../../config';
const server_backend = config.API_URL;

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { setUser } = useContext(UserContext);
  const navigate = useNavigate();

  const loginUser = async (e) => {
    e.preventDefault();
    let userData;
setLoading(true);
    try {
      const response = await axios.post(`${server_backend}/public/login`, {
        username,
        password
      });


      if (response.data.RES_CODE === "00") {
        Swal.fire({
          icon: 'success',
          title: 'Login Successful',
          showConfirmButton: false,
          timer: 3000
        });

        const userData = response.data.RES_OTHERS.vToken;
        const username = response.data.RES_RESULT.usr_codigo;
        const Role = response.data.RES_RESULT.designation;
        setUser(userData);
        sessionStorage.setItem('userPermissions', JSON.stringify(response.data.RES_RESULT.Objects));
        localStorage.setItem('userData', JSON.stringify(userData));
        localStorage.setItem('yourName', JSON.stringify(username));
        localStorage.setItem('yourRole', JSON.stringify(Role));
        navigate('/main-panel');
        window.location.reload();
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Please try again or click Reset Password? to reset it.',
          showConfirmButton: false,
          timer: 1000
        });
      }
    } catch (error) {
      
      Swal.fire({ 
        icon: 'error',
        title: 'Error',
        text: 'Invalid Credentials',
        showConfirmButton: false,
        timer: 6000
      });
    } finally {
      setLoading(false);
    }

    setUser(userData);
  };

  function togglePasswordVisibility() {
    const passwordInput = document.getElementById('password');
    const passwordIcon = document.getElementById('password-addon').querySelector('i');

    if (passwordInput.type === 'password') {
      passwordInput.type = 'text';
      passwordIcon.classList.remove('ri-eye-fill');
      passwordIcon.classList.add('ri-eye-off-fill');
    } else {
      passwordInput.type = 'password';
      passwordIcon.classList.remove('ri-eye-off-fill');
      passwordIcon.classList.add('ri-eye-fill');
    }
  }

  return (
    <div className="auth-page-wrapper py-5 d-flex justify-content-center align-items-center min-vh-100"
      style={{
        backgroundImage: 'url(assets/images/dbc-london-build-2.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        
      }}>

      <div className="auth-page-content overflow-hidden pt-lg-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="card overflow-hidden">
                <div className="row g-0">
                  <div className="col-lg-6">
                    <div
                      className="p-lg-5 p-4 h-100"
                      style={{
                        backgroundImage: 'url(assets/images/logo.png)',
                        backgroundSize: 'cover',
                        backgroundPosition: 'center'
                      }}
                    >
                      {/* <div className="bg-overlay"></div> */}
                      <div className="position-relative h-100 d-flex flex-column">
                        <div className="mb-4" >
                         {/*  <Link to="" className="d-block">
                            <img src="assets/images/dbclondon-sm.png" alt="" height="120" width="120" style={{ borderRadius: "20px" }} />
                          </Link> */}
                        </div>
                        {/* <div className="mt-auto">
                          <div className="mb-3">
                            <i className="ri-double-quotes-l display-4 text-success"></i>
                          </div>

                          <div id="qoutescarouselIndicators" className="carousel slide" data-bs-ride="carousel">
                            <div className="carousel-indicators">
                              <button type="button" data-bs-target="#qoutescarouselIndicators" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
                              <button type="button" data-bs-target="#qoutescarouselIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
                              <button type="button" data-bs-target="#qoutescarouselIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
                            </div>
                            <div className="carousel-inner text-center text-white pb-5">
                              <div className="carousel-item active">
                                <p className="fs-15 fst-italic">"Innovating in precious material smelting, ensuring quality and precision in every piece."</p>
                              </div>
                              <div className="carousel-item">
                                <p className="fs-15 fst-italic">"Transforming raw materials into masterpieces with advanced technology and expertise."</p>
                              </div>
                              <div className="carousel-item">
                                <p className="fs-15 fst-italic">"Committed to excellence at every step of the smelting and refining process."</p>
                              </div>
                            </div>

                          </div>
                        </div> */}
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="p-lg-5 p-4">
                      <div>
                        <h5 className="text-primary">Admin Access</h5>
                        <p className="text-muted">Sign in to manage DBC London.</p>
                      </div>

                      <div className="mt-4">
                        <form onSubmit={loginUser}>
                          <div className="mb-3">
                            <label htmlFor="username" className="form-label">Username</label>
                            <input
                              type="text"
                              className="form-control"
                              id="username"
                              placeholder="Enter username"
                              value={username}
                              onChange={(e) => setUsername(e.target.value)}
                              required
                            />
                          </div>

                          <div className="mb-3">
                            <div className="float-end">
                              <Link to="/password-reset" className="text-muted">Forgot password?</Link>
                            </div>
                            <label className="form-label" htmlFor="password-input">Password</label>
                            <div className="position-relative auth-pass-inputgroup mb-3">
                              <input
                                type="password"
                                className="form-control pe-5"
                                placeholder="Enter password"
                                id="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                              />
                              <button className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted" type="button" id="password-addon" onClick={togglePasswordVisibility}>
                                <i className="ri-eye-fill align-middle"></i>
                              </button>
                            </div>
                          </div>

                         {/*  <div className="form-check">
                            <input className="form-check-input" type="checkbox" value="" id="auth-remember-check" />
                            <label className="form-check-label" htmlFor="auth-remember-check">Remember me</label>
                          </div> */}

                           <div className="mt-4">
                      {loading ? (
                        <button
                          className="btn w-100 fw-bold"
                          style={{
                            background: "linear-gradient(45deg, #ff6b00, #ff2a00)",
                            border: "none",
                            borderRadius: "10px",
                            color: "white",
                            padding: "10px",
                            transition: "0.3s"
                          }}
                          disabled
                        >
                          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                          Signing In...
                        </button>
                      ) : (
                        <button
                          className="btn w-100 fw-bold"
                          style={{
                            background: "linear-gradient(45deg, #ff6b00, #ff2a00)",
                            border: "none",
                            borderRadius: "10px",
                            color: "white",
                            padding: "10px",
                            transition: "0.3s"
                          }}
                        >
                          Sign In
                        </button>
                      )}
                    </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <footer className="footer start-0">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="text-center text-white">
                <p className="mb-0">Copyright &copy; {new Date().getFullYear()} <Link to={process.env.REACT_APP_URL_SITE} target="_blank" rel="noopener noreferrer"> DBC  </Link>All Rights Reserved.<Link to={process.env.REACT_APP_URL_HELP} target="_blank" rel="noopener noreferrer"> Help</Link></p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Login;
